// @flow

import moveEstimateItem from '../../../Services/moveEstimateItem';
import type { MoveEstimateItemParams } from '../../../types';

export default (params: MoveEstimateItemParams) => async (dispatch: Function) => dispatch(moveEstimateItem(params))